import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import { RadioCardGroup } from '@telus/koodo-ui-kit'
import { PHONE_NUMBER_OPTIONS } from '@apps/utils/constants'
import { getById, getBySlug } from '@apps/utils/contentful'
import { useSelector } from 'react-redux'
import Sites from '@sites/index'

const ChoosePhoneOption = ({ onSelect, selectedOption, pushClickAnalytics }) => {
  const {
    userType,
    content: { pageContent },
    user: { selectedLanguage }
  } = useSelector((state) => state.common)

  const isDealer = userType === Sites.dealer
  const pagePrefix = isDealer ? 'Dealer' : 'Consumer'
  const textContent = useMemo(() => {
    const phoneNumberPage = getById(pageContent, `phoneNumberPage${pagePrefix}`)[selectedLanguage]
    if (!phoneNumberPage) return {}
    const { shortTextFields } = phoneNumberPage
    return {
      newPhoneNumberOption: getBySlug(shortTextFields, 'new-phone-number-option')?.value,
      transferExistingNumberOption: getBySlug(shortTextFields, 'transfer-existing-number-option')
        ?.value
    }
  }, [pageContent, selectedLanguage])

  const items = useMemo(() => [
    {
      id: PHONE_NUMBER_OPTIONS.CHOOSE_A_NEW_NUMBER,
      title: textContent?.newPhoneNumberOption
    },
    {
      id: PHONE_NUMBER_OPTIONS.TRANSFER_NUMBER,
      title: textContent?.transferExistingNumberOption
    }
  ], [textContent])

  const handleChange = (selectedId) => {
    onSelect(selectedId)
    const selected = items.find((item) => item.id === selectedId)
    if (pushClickAnalytics && selected?.title) {
      pushClickAnalytics(`Selected Phone Number Option: ${selected.title}`)
    }
  }

  const radioCardTokens = ({ checked }) => ({
    backgroundColor: checked ? '#000000' : '#ffffff',
    borderColor: checked ? '#000000' : '#c9c8c8',
    borderRadius: 4,
    borderWidth: 1,
    color: checked ? '#ffffff' : '#000000',
    fontSize: 16,
    fontWeight: '700',
    lineHeight: 1.5,
    minWidth: 0,
    paddingBottom: 12,
    paddingLeft: 16,
    paddingRight: 16,
    paddingTop: 12,
    radioCheckedBackgroundColor: checked ? '#ffffff' : '#000000',
    radioCheckedSize: 16,
    radioInputBackgroundColor: checked ? '#000000' : '#ffffff',
    radioInputBorderColor: checked ? '#ffffff' : '#000000',
    radioInputBorderWidth: 2,
    radioInputSize: 24,
    radioOuterBorderColor: 'transparent',
    radioOuterBorderGap: 0,
    radioOuterBorderWidth: 0,
    radioSpace: 2
  })

  return (
    <div className="mt-4">
      <RadioCardGroup
        accessibilityLabel={selectedLanguage === 'fr' ? 'Choisir une option de numero de telephone' : 'Choose phone number option'}
        checkedId={selectedOption || ''}
        items={items}
        name="phone-number-option"
        onChange={handleChange}
        radioCardTokens={radioCardTokens}
        tokens={{
          direction: 'column',
          fieldSpace: 0,
          space: 3
        }}
        variant={{ fullWidth: true }}
      />
    </div>
  )
}

ChoosePhoneOption.propTypes = {
  onSelect: PropTypes.func,
  selectedOption: PropTypes.string,
  pushClickAnalytics: PropTypes.func
}

export default ChoosePhoneOption
